// extracted by mini-css-extract-plugin
export default {"title":"bKjNKfXNqo4c2806xYlX","size-sm":"T1Kq4gbTRYSME4dhFYMV"};